import React from 'react'
import "./Footer.css"

export default function Footer() {
  return (
    <div className='footer'>
            <h4 className='footer-credits'>Made With   &#10084;  By Logeshwaran</h4>        
    </div>
  )
}
